import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

interface PageContentProps {
  children: React.ReactNode;
  isPageHeightAuto?: boolean;
  className?: string;
}

const PageContent: React.FC<PageContentProps> = ({
  children,
  isPageHeightAuto = true,
  className,
}) => {
  const classes = useStyles();

  return (
    <Box
      className={clsx(classes.pageLayout, className)}
      style={{ height: isPageHeightAuto ? 'auto' : 'calc(100vh - 110px)' }}
    >
      {children}
    </Box>
  );
};
const useStyles = makeStyles((theme) => ({
  pageLayout: {
    display: 'flex',
    flexGrow: 1,
    marginLeft: 'auto',
    marginRight: 'auto',
    background: theme.palette.secondary.main,
    overflow: 'hidden',
  },
}));

export default PageContent;
